module.exports = __webpack_public_path__ + "img/logo_rounded.4c5979b4.png";